module.exports = __webpack_public_path__ + "media/images/talent/results-1789690938e48a10f7c4274b0d41be32.png";